const textarea = {

	elem: {
		count: document.querySelectorAll('textarea[maxlength]')
	},

	init() {
		if(textarea.elem.count.length > 0) {
			textarea.elem.count.forEach(function(element) {
				let maxlength = element.getAttribute('maxlength');
				element.insertAdjacentHTML('afterend', `<div class="text-count">${maxlength}/${maxlength} Characters Remaining</div>`);
				element.addEventListener('keyup', textarea.onKeyUp);
			});
		}
	},

	// onKeyUp(): when typing in a textarea with a hard character limit, update the tooltip which shows the number of characters remaining
	onKeyUp(event) {
		let target = event.target;
		let maxlength = event.target.getAttribute('maxlength');
		let remaining = maxlength - event.target.value.length;
		target.closest('.editing-form-control-nested-control').querySelector('.text-count').innerHTML = `${remaining}/${maxlength} Characters Remaining`;
	}

}

export { textarea }
